import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./css/whatsapp-button.css";

export default function WhatsAppButton() {
	const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || "9826311996";
	
	const handleWhatsAppClick = () => {
		const whatsappURL = `https://wa.me/${whatsappNumber}`;
		window.open(whatsappURL, "_blank");
	};

	return (
		<button 
			className="whatsapp-button" 
			onClick={handleWhatsAppClick}
			title="Chat with us on WhatsApp"
		>
			<FaWhatsapp size={28} />
		</button>
	);
}
